import React, {useCallback} from 'react';
import getConfig from 'next/config';

import Link from '~/src/components/link/Link';
import KeyboardListener from '~/src/components/listener/keyboard/KeyboardListener';
import CloseX from '~/src/components/svg/action/CloseX';
import Modal from '~/src/components/modal/Modal';
import MainLogo from '~/src/components/svg/navigation/MainLogo';

import {GtmEvents} from '~/src/utilities/constants/tracking';
import {withSettingsContext} from '~/src/components/context/SettingsContext';
import {trackGtm} from '~/src/utilities/tracking/gtm';
import initPolyglot from '~/src/utilities/libs/polyglot';

import i18nStrings from './FeatureModal.i18n.json';
import css from './FeatureModal.module.scss';

const {publicRuntimeConfig: config} = getConfig();

const getTranslation = initPolyglot(i18nStrings);

const FeatureModal = ({targetUri, onClose, title, ...props}) => {
    const onLoginClick = useCallback(() => {
        props.onLogin ? props.onLogin() : trackGtm(GtmEvents.FEATURE_OVERLAY_LOGIN, null);
        window.location.href = encodeURI(`${config.accounts.loginUrl}?target_uri=${targetUri}&lang=${config.language}`);
    }, [targetUri]);

    const onRegisterClick = useCallback(() => {
        props.onRegister ? props.onRegister() : trackGtm(GtmEvents.FEATURE_OVERLAY_REGISTER, null);
        window.location.href = encodeURI(`${config.accounts.registerUrl}?target_uri=${targetUri}`);
    }, [targetUri]);

    const onMoreInfoClick = useCallback(() => {
        props.onMoreInfo ? props.onMoreInfo() : trackGtm(GtmEvents.FEATURE_OVERLAY_INFORMATION, null);
    }, []);

    return (
        <Modal>
            <div className={css.featureModal} data-testid="FeatureModal">
                <div className={css.featureModalContainer}>
                    <div className={css.loginItemInnerContainer}>
                        <div className={css.header}>
                            <div className={css.mainlogo}>
                                <MainLogo />
                            </div>
                            <div className={css.closeButton} data-testid="FeatureModalClose" onClick={onClose}>
                                <CloseX />
                            </div>
                        </div>
                        <div className={css.loginTitle}>{title || getTranslation('title')}</div>
                        <div className={css.textContainer}>
                            <Link href={config.accounts.moreInfoURL} onClick={onMoreInfoClick} target="_blank" className={css.descriptionLink}>
                                {getTranslation('moreInfoLink')}
                            </Link>
                        </div>
                        <button className={css.registerButton} onClick={onRegisterClick}>
                            {getTranslation('registerButton')}
                        </button>
                        <div className={css.alreadyRegisteredContainer}>
                            <div className={css.alreadyRegisteredText}>{getTranslation('alreadyRegistered')}</div>
                            <button className={css.loginButton} onClick={onLoginClick}>
                                {getTranslation('loginButton')}
                            </button>
                        </div>
                    </div>
                </div>
                <KeyboardListener onEsc={onClose} />
            </div>
        </Modal>
    );
};

export default withSettingsContext(FeatureModal);
